import { FormattedMessage, FormattedPlural } from 'react-intl';

import { NewChatButton } from '../chatList/NewChatButton';
import { FleetGroupFilter } from '../fleetGroupFilter/FleetGroupFilterSelect';
import type { Chat } from '../../services/chatAdministrationApi';

type ChatListHeaderProps = {
    chats: Chat[];
    openChatsCount?: number;
    showFleetGroupFilter?: boolean;
    totalUnreadMessageCount?: number;
};

export const ChatListHeader = (props: ChatListHeaderProps) => {
    const { openChatsCount = 0, showFleetGroupFilter = false, totalUnreadMessageCount = 0 } = props;

    return (
        <div
            className='ChatListHeader padding-x-15 padding-y-15 bg-lightest border border-bottom-only'
            data-testid='open-chats-header'
        >
            <div className='display-flex align-items-center'>
                <div className='flex-1-1'>
                    <div className='text-size-18 text-medium margin-0 text-color-darker'>
                        <FormattedMessage
                            id='intl-msg:chat.list.label.openChats'
                            values={{
                                count: openChatsCount,
                            }}
                        />
                    </div>
                    <div className='text-color-darker text-size-12'>
                        {totalUnreadMessageCount === 0 && (
                            <FormattedMessage id='intl-msg:chat.list.label.newMessages.zero' />
                        )}
                        {totalUnreadMessageCount > 0 && (
                            <FormattedPlural
                                one={
                                    <FormattedMessage
                                        id='intl-msg:chat.list.label.newMessages.one'
                                        values={{ count: totalUnreadMessageCount }}
                                    />
                                }
                                other={
                                    <FormattedMessage
                                        id='intl-msg:chat.list.label.newMessages.other'
                                        values={{ count: totalUnreadMessageCount }}
                                    />
                                }
                                value={totalUnreadMessageCount}
                            />
                        )}
                    </div>
                </div>
                <NewChatButton />
            </div>
            {showFleetGroupFilter && <FleetGroupFilter chats={props.chats} className='padding-top-10' />}
        </div>
    );
};
